import { useEffect, useState } from 'react'
import useReduxStore from '../../../hooks/useReduxStore'
import { PHASE_LIST, TREATMENT_ADD, TREATMENT_DELETE, TREATMENT_LIST, TREATMENTPLANID_LIST, TREATMENTPLAN_UPDATE_IDS, TREATMENTPLAN_CHANGE_STATUS, TREATMENTPLAN_DISCOUNT, PROVIDER_LIST } from '../../../repository/charting'
import {
    GENERATE_CLAIM_FORM, GET_TREATMENT_PLACE_LIST, PATIENT_DETAILS_SUPERBILL, PATIENT_DETAILS_SUPERBILL_GENERATE, LIST_PATIENT_DETAILS_SUPERBILL,
    GET_PATIENT_DETAILS_SUPERBILL, PATIENT_DETAILS_SUPERBILL_UPDATE, GENERATE_FORM_SUPERBILL
} from '../../../repository/LedgerRepo'
import { toast } from 'react-toastify'
import { CONDITIOIN_LIST, MATERIAL_LIST, PROCEDURE_CATEGORY_LIST, Procedure_Code_List, DIAGNOSIS_CODE_LIST } from '../../../repository/setup'
import moment from 'moment-timezone'
import {
    bridgeTypeArry, conditionsArray, crownTypeArry, eruptedTypeArry, impactedTypeArry, implantTypeArry, missingTypeArry,
    restorationTypeArry, rootCanalTypeArry, unMissingTypeArry, watchArrowArray
} from '../../Charting/Hooks/MaterialType_Categories'
import { modalEnum } from '../../../constant'
import { add, clearTeatmentPlanData } from '../../../Slices/TreatmentPlanSlice'
import { useNavigate, useParams } from 'react-router-dom'
import { handleListPagination, requiredMessage, requiredSelect } from '../../../Utils'

import { GET_PROVIDER_HYGIENIST_LIST } from '../../../repository/schedulerRepo'
const UseTreatmentPlan = () => {
    const { selector: user } = useReduxStore('auth')
    const { selector: PatientData, Dispatch } = useReduxStore("PatientData")

    const [tplanId, setTplanId] = useState(1);
    const [phaseId, setPhaseId] = useState({
        phaseId: 'ALL',
        lastPhaseId: 1,
    });
    const [orderId, setOrderId] = useState({
        orderId: 'ALL',
        lastOrderId: 1
    });
    const [tplanDate, setTplanDate] = useState(null);
    const [tPlanIdList, setPPlanIdList] = useState([])
    const [phaseList, setPhaseList] = useState([])
    const [orderList, setOrderList] = useState([])
    const [listData, setListData] = useState([])
    const [spinner, setSpinner] = useState(false)
    const [totalCount, settotalCount] = useState(0)
    const [controller, setController] = useState({ page: 1, rowsPerPage: 10, searchPage: 1 })
    const [categoryList, setCategoryList] = useState([])
    const [procedureList, setProcedureList] = useState([])
    const [selectedProcedureCode, setSelectedProcedureCode] = useState([])
    const [selectProcedureModal, setSelectProcedureModal] = useState({
        open: false,
        data: null
    })
    const [toothModal, setToothModal] = useState({
        open: false,
        data: null
    })
    const [palceOfTreatmentlist, setPlaceOfTreatment] = useState([])
    const [submitClaimFormModal, setSubmitClaimFormModal] = useState(modalEnum)
    const [submitClaimForm, setSubmitClaimForm] = useState({
        placeOftreatment: "",
        encloser: "No",
        isDental: "No",
        isMedical: "No",
        treatmentOfOrtho: "No",
        orthoDate: null,
        monthOfTreatment: "",
        treatmentResultingForm: null,
        replacementOfProsthesis: "No",
        placementDate: null,
        dateAutoAccident: null,
        autoAccidentState: "",
        remarks: ""
    })
    const [claimFormError, setClaimFormError] = useState({})


    const [active, setActive] = useState('')
    const [currentProcedure, setCurrentProcedure] = useState('')
    const [filter, setFilter] = useState({
        category: '',
        code: null,
        description: null,
        search: null
    })
    const [selectedItems, setSelectedItems] = useState([]);
    const [teethsList, setTeethsList] = useState([
        { toothNumber: '1', toothType: 'molar', selected: false },
        { toothNumber: '2', toothType: 'molar', selected: false },
        { toothNumber: '3', toothType: 'molar', selected: false },
        { toothNumber: '4', toothType: 'premolar', selected: false },
        { toothNumber: '5', toothType: 'premolar', selected: false },
        { toothNumber: '6', toothType: 'canine', selected: false },
        { toothNumber: '7', toothType: 'incisor', selected: false },
        { toothNumber: '8', toothType: 'incisor', selected: false },
        { toothNumber: '9', toothType: 'incisor', selected: false },
        { toothNumber: '10', toothType: 'incisor', selected: false },
        { toothNumber: '11', toothType: 'canine', selected: false },
        { toothNumber: '12', toothType: 'premolar', selected: false },
        { toothNumber: '13', toothType: 'premolar', selected: false },
        { toothNumber: '14', toothType: 'molar', selected: false },
        { toothNumber: '15', toothType: 'molar', selected: false },
        { toothNumber: '16', toothType: 'molar', selected: false },

        { toothNumber: 'A', toothType: 'molar', selected: false },
        { toothNumber: 'B', toothType: 'molar', selected: false },
        { toothNumber: 'C', toothType: 'canine', selected: false },
        { toothNumber: 'D', toothType: 'incisor', selected: false },
        { toothNumber: 'E', toothType: 'incisor', selected: false },
        { toothNumber: 'F', toothType: 'incisor', selected: false },
        { toothNumber: 'G', toothType: 'incisor', selected: false },
        { toothNumber: 'H', toothType: 'canine', selected: false },
        { toothNumber: 'I', toothType: 'molar', selected: false },
        { toothNumber: 'J', toothType: 'molar', selected: false },
        { toothNumber: 'K', toothType: 'molar', selected: false },
        { toothNumber: 'L', toothType: 'molar', selected: false },
        { toothNumber: 'M', toothType: 'canine', selected: false },
        { toothNumber: 'N', toothType: 'incisor', selected: false },
        { toothNumber: 'O', toothType: 'incisor', selected: false },
        { toothNumber: 'P', toothType: 'incisor', selected: false },
        { toothNumber: 'Q', toothType: 'incisor', selected: false },
        { toothNumber: 'R', toothType: 'canine', selected: false },
        { toothNumber: 'S', toothType: 'molar', selected: false },
        { toothNumber: 'T', toothType: 'molar', selected: false },

        { toothNumber: '32', toothType: 'molar', selected: false },
        { toothNumber: '31', toothType: 'molar', selected: false },
        { toothNumber: '30', toothType: 'molar', selected: false },
        { toothNumber: '29', toothType: 'premolar', selected: false },
        { toothNumber: '28', toothType: 'premolar', selected: false },
        { toothNumber: '27', toothType: 'canine', selected: false },
        { toothNumber: '26', toothType: 'incisor', selected: false },
        { toothNumber: '25', toothType: 'incisor', selected: false },
        { toothNumber: '24', toothType: 'incisor', selected: false },
        { toothNumber: '23', toothType: 'incisor', selected: false },
        { toothNumber: '22', toothType: 'canine', selected: false },
        { toothNumber: '21', toothType: 'premolar', selected: false },
        { toothNumber: '20', toothType: 'premolar', selected: false },
        { toothNumber: '19', toothType: 'molar', selected: false },
        { toothNumber: '18', toothType: 'molar', selected: false },
        { toothNumber: '17', toothType: 'molar', selected: false },
    ]);
    const [selectedTooths, setSelectedTooths] = useState([])
    const [selectToothModal, setSelectToothModal] = useState({
        open: false,
        data: {}
    })
    const [surfaceModal, setSurfaceModal] = useState({
        open: false,
        data: {}
    })
    const [surfaces, setSurfaces] = useState([
        { label: 'Lingual', value: 'L', checked: false },
        { label: 'Buccal', value: 'B', checked: false },
        { label: 'Mesial', value: 'M', checked: false },
        { label: 'Inscisal', value: 'I', checked: false },
        { label: 'Occlusal', value: 'O', checked: false },
        { label: 'Distal', value: 'D', checked: false },
    ]);
    const [selectedSurface, setSelectedSurface] = useState([])
    const [material, setMaterial] = useState([])
    const [selectMaterial, setSelectMaterial] = useState([])
    const [count, setCount] = useState({ teethCount: '', surfaceCount: '' })
    const [deleteModal, setDeleteModal] = useState({
        open: false,
        data: null
    })

    const [changeIdModal, setChangeIdModal] = useState(modalEnum)
    const [changeIdForm, setChangeIdForm] = useState({
        tplanId: '',
        phaseId: '',

    })
    const [changeStatusModal, setChangeStatusModal] = useState(modalEnum)
    const [selectedOption, setSelectedOption] = useState('');
    const [discount, setDiscount] = useState('');
    const [providerData, setProviderData] = useState([])
    const [providerId, setproviderId] = useState(0);
    const [submissionStatus, setSubmissionStatus] = useState('all');
    const [conditionList, setConditionList] = useState([])
    const [materialList, setMaterialList] = useState([])
    const [restorativeCondition, setRestorativeCondition] = useState([])
    const [dentitionAge, setDentitionAge] = useState('')
    const [superBillIstrue, setSuperBillIstrue] = useState(false)
    const [icdCodes, setIcdCodes] = useState([]);
    const [newdata, setNewdata] = useState({
        totalAmount: "0",
        caseType: "",
        providerId: "",
        billingProviderId: "",
        renderingProviderId: "",
        showReferringProvider: false,
        referringProviderId: "",
        typeOfService: "",
        placeOfService: "",
        encloser: "No",
        isDental: "No",
        isMedical: "No",
        treatmentOfOrtho: "No",
        orthoDate: null,
        monthOfTreatment: "",
        treatmentResultingForm: null,
        replacementOfProsthesis: "No",
        placementDate: null,
        dateAutoAccident: null,
        autoAccidentState: "",
        remarks: "",
        cptCode: [],
        modifier: [{ modifierCode1: "", modifierCode2: "", modifierCode3: "", modifierCode4: "" }],
        // icdCodes: { icd9: [], icd10: [] },
        icdCodes: []
    })
    const [responsibleParty, setResponsibleParty] = useState('INSURANCE');
    const [acceptAssignment, setAcceptAssignment] = useState('A')



    const { id } = useParams();





    const submissionStatusArray = [
        { title: 'ALL', value: 'all' },
        { title: 'YES', value: true },
        { title: 'NO', value: false },
    ]

    const navigate = useNavigate()
    const clearClaimForm = () => {
        setNewdata({
            placeOftreatment: "",
            encloser: "No",
            treatmentOfOrtho: "No",
            orthoDate: null,
            monthOfTreatment: "",
            Occupational: "No",
            autoAccident: "No",
            other: "No",
            replacementOfProsthesis: "No",
            placementDate: null,
            dateAutoAccident: null,
            autoAccidentState: "",
            remarks: ""
        })
        setClaimFormError({})
    }
    useEffect(() => {
        getNumberList()
        getPhaseList()
        getProviderList()
        Dispatch(clearTeatmentPlanData())
        // getOrderList()
    }, [])

    useEffect(() => {
        treatmentList()
    }, [controller, PatientData])

    useEffect(() => {
        if (selectProcedureModal?.open) {
            getProcedureList()
        }
    }, [filter?.category])


    const getNumberList = async () => {
        try {
            let payload = {
                clinicId: user?.clinic_id,
                patientId: PatientData?.id,
                // phaseId: 'ALL',
                // orderId: '2',
            }
            // setSpinner(true)
            let response = await TREATMENTPLANID_LIST(payload)
            setPPlanIdList(response?.data)
        } catch (error) {
            toast.error(error)
        }
        // setSpinner(false)
    }
    const getPhaseList = async () => {
        try {
            let payload = {
                clinicId: user?.clinic_id,
                patientId: PatientData?.id,
            }
            // setSpinner(true)
            let response = await PHASE_LIST(payload)
            let updatedPhaseList = ['ALL', ...response?.data];
            setPhaseList(updatedPhaseList)
            // setPhaseList(response?.data)
            setPhaseId((pre) => ({ ...pre, lastPhaseId: response?.data?.[response?.data?.length - 1] }))

        } catch (error) {
            toast.error(error)
        }
        // setSpinner(false)
    }
    // const getOrderList = async () => {
    //     try {
    //         let payload = {
    //             clinicId: user?.clinic_id,
    //             patientId: PatientData?.id,
    //         }
    //         setSpinner(true)
    //         let response = await ORDER_LIST(payload)
    //         let updatedOrderList = ['ALL', ...response?.data];
    //         setOrderList(updatedOrderList)
    //         setOrderId((pre) => ({ ...pre, lastOrderId: response?.data?.[response?.data?.length - 1] }))

    //     } catch (error) {
    //         toast.error(error)
    //     }
    //     setSpinner(false)
    // }
    const getProcedureCategoryList = async () => {
        try {
            let payload = {
                count: 1000,
                page: 1,
                searchName: '',
                isDeleted: false,
                clinicId: user?.clinic_id,
            }
            setSpinner(true)
            let response = await PROCEDURE_CATEGORY_LIST(payload)
            setSelectProcedureModal((pre) => ({ ...pre, open: true }));
            setCategoryList(response?.data)
        } catch (error) {
            toast.error(error?.message)
            setCategoryList([])
        }
        setSpinner(false)
    }
    const getProcedureList = async () => {
        setSpinner(true)
        try {
            let payload = {
                category: filter?.category ? filter?.category.toString() : null,
                clinicId: user?.clinic_id,
                code: filter?.code ? filter?.code : null,
                description: filter?.description ? filter?.description : null
            }
            let response = await Procedure_Code_List(payload)
            setProcedureList(response?.data)
            setCurrentProcedure(active)
        } catch (error) {
            setProcedureList([])
        }
        setSpinner(false)
    }
    const treatmentList = async () => {
        try {
            let payload = {
                count: controller.rowsPerPage,
                page: controller.page,
                clinicId: user?.clinic_id,
                patientId: PatientData?.id,
                phaseId: phaseId?.phaseId,
                orderId: orderId?.orderId,
                type: 'COMPLETED',
                tplanId: Number(tplanId),
                date: tplanDate ? moment(tplanDate)?.format('YYYY-MM-DD') : null,
                providerId: providerId,
                isClaimSubmitted: submissionStatus == 'all' ? null : submissionStatus
            }
            setSpinner(true)
            let response = await TREATMENT_LIST(payload)
            setListData(response?.data)
            settotalCount(response.count);
            setSelectedItems([])
        } catch (error) {
            toast.error(error)
            setListData([])
            settotalCount(0);

        }
        setSpinner(false)
    }
    const ApplyFilter = () => {
        setController((pre) => ({ ...pre, searchPage: pre?.page, page: 1 }))
    }
    // Reset Filter
    const resetFilter = () => {
        setController((pre) => ({ ...pre, page: pre.searchPage, searchPage: 1 }))
        setFilter((pre) => ({ ...pre, search: '' }))
        setTplanDate(null)
        setTplanId(1)
        setproviderId(0)
        setSubmissionStatus('all')
        setPhaseId({
            phaseId: 'ALL',
            lastPhaseId: 1,
        })
    }
    const handleSelectedTooths = (event, toothNumber) => {
        // setPrimaryTeeths(prevTooths =>
        //     prevTooths?.map(tooths =>
        //         tooths.toothNumber === toothNumber ? { ...tooths, selected: event.target.checked } : tooths
        //   )
        // );
        setTeethsList(prevTooths =>
            prevTooths?.map(tooths =>
                tooths.toothNumber === toothNumber ? { ...tooths, selected: event.target.checked } : tooths
            )
        );
    };
    const handleSubmitTooths = () => {
        // setSelectedToothsCounts(permanentTeeths.filter(tooth => tooth.selected).length + primaryTeeths.filter(tooth => tooth.selected).length);
        // setSelectedTooths([...permanentTeeths.filter(tooth => tooth.selected), ...primaryTeeths.filter(tooth => tooth.selected)] )
        if (!teethsList.filter(tooth => tooth.selected).length) return toast.warn("Please select tooth number")
        setCount((pre) => ({ ...pre, teethCount: teethsList.filter(tooth => tooth.selected).length }));
        setSelectedTooths(teethsList.filter(tooth => tooth.selected))
        setSelectToothModal({ data: null, open: false })
    }
    const handleSelectedSurface = (event, label) => {
        setSurfaces(prevSurfaces =>
            prevSurfaces.map(surface =>
                surface.label === label ? { ...surface, checked: event.target.checked } : surface
            )
        );
    };
    const handleSubmitSurfaces = () => {
        if (!surfaces.filter(surface => surface.checked).length) return toast.warn("Please select surface")
        setCount((pre) => ({ ...pre, surfaceCount: surfaces.filter(surface => surface.checked).length }));
        setSelectedSurface(surfaces.filter(surface => surface.checked))
        setSurfaceModal({ data: null, open: false })
    }
    const getMaterial = (category) => {
        if (category === 'RESTORATIVE') {
            setMaterial(restorationTypeArry)
        }
        else if (category === 'IMPLANT SERVICES') {
            setMaterial(implantTypeArry)
        } else if (category === 'MISSING') {
            setMaterial(missingTypeArry)
        } else if (category === 'PREVENTIVE') {
            setMaterial(restorationTypeArry)
        } else if (category === 'MAXILLOFACIAL PROSTHETICS') {
            setMaterial(bridgeTypeArry)
        } else if (category === 'ADJUNCTIVE GENERAL SERVICES') {
            setMaterial(impactedTypeArry)
        } else if (category === 'ENDODONTICS') {
            setMaterial(eruptedTypeArry)
        } else if (category === 'ORTHODONTICS') {
            setMaterial(watchArrowArray)
        } else if (category === 'PERIODONTICS') {
            setMaterial(conditionsArray)
        } else if (category === 'UNMISSING') {
            setMaterial(unMissingTypeArry)
        } else if (category === 'FIXED PROSTHODONTICS') {
            setMaterial(crownTypeArry)
        } else if (category === 'REMOVABLE PROSTHODONTICS') {
            setMaterial(rootCanalTypeArry)
        } else if (category === 'ORAL AND MAXILLOFACIAL SURGERY') {
            setMaterial(watchArrowArray)
        }
        // else if (category === 'ORAL AND MAXILLOFACIAL SURGERY') {
        //     setMaterial(watchArrowArray)
        // }
        // else if (category === 'DECAY') {
        //     setMaterial(restorationTypeArry)
        // }
    }
    const addTreatmentPlan = async () => {
        if (!restorativeCondition?.length) return toast.warn('Please select restorative condition')
        if (!selectMaterial?.length) return toast.warn('Please select material')
        if (!selectedTooths?.length) return toast.warn('Please select teeth')
        if (!dentitionAge) return toast.warn('Please select age')
        if (!providerId?.length) return toast.warn('Please select provider')
        let updatedSurface = selectedSurface.map(obj => {
            const { checked, ...rest } = obj;
            return rest;
        });
        let newSelectedToothData = selectedTooths?.map((cur, index) => {
            const toothNo = /^[0-9]+$/.test(cur?.toothNumber) ? Number(cur?.toothNumber) : cur?.toothNumber;
            return {
                toothNo: toothNo?.toString(),
                // toothNo: +cur?.toothNumber,
                surfaceObjects: updatedSurface,
                tooth_roots: ["Layer_1"],
                toothType: cur?.toothType,
                type: "TXPLANS",
                selectedMaterialType: selectMaterial?.length ? selectMaterial?.[0]?.name : '',
                selectedCategory: restorativeCondition?.[0]?.name,
                // date: moment(tplanDate).format('YYYY-MM-DD'),
                // createdDate: moment(tplanDate).format('YYYY-MM-DD hh:mm:s'),
                date: tplanDate ? moment(tplanDate).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
                createdDate: tplanDate ? moment(tplanDate).format('YYYY-MM-DD hh:mm:s') : moment(new Date()).format('YYYY-MM-DD hh:mm:s'),

                adaCode: {
                    code: selectedProcedureCode?.code,
                    description: selectedProcedureCode?.description,
                    id: selectedProcedureCode?.id,
                    abbrev: selectedProcedureCode?.abbrev,
                    billable: selectedProcedureCode?.billable,
                    fee1: selectedProcedureCode?.fee1,
                    fee2: selectedProcedureCode?.fee2
                }
            }
        })

        try {
            const payload = {
                clinicId: user?.clinic_id,
                patientId: PatientData?.id,
                doctorId: providerId?.[0]?.userId,
                tplanId: tplanId,
                phaseId: phaseId?.phaseId === 'ALL' ? phaseId?.lastPhaseId : phaseId?.phaseId,
                orderId: orderId?.orderId === 'ALL' ? orderId?.lastOrderId : orderId?.orderId,
                TreatmentPlanData: [...newSelectedToothData],
                age: dentitionAge?.[0]?.value



            }
            setSpinner(true)
            const response = await TREATMENT_ADD(payload)
            treatmentList()
            clear()
            clearProcedure()
            toast.success(response?.message)
            setSpinner(false)

        }
        catch {
            setSpinner(false)
        }
    }
    const handleDelete = async (selectData) => {
        try {
            let payload = {
                clinicId: user?.clinic_id,
                patientId: PatientData?.id,
                TreatmentPlanData: selectData ? selectedItems?.length ? selectedItems?.map((item) => item?.id) : [] : deleteModal?.data?.id ? [deleteModal.data?.id] : []
            }
            setSpinner(true)
            let response = await TREATMENT_DELETE(payload)
            handleListPagination(listData, treatmentList, controller, setController)
            setDeleteModal({ data: null, open: false });
            toast.success(response?.message)
            treatmentList()
        } catch (error) {
            toast.error(error)
        }
        setSpinner(false)
    }
    const clear = () => {
        setToothModal({ data: {}, open: false });
        setSelectedSurface([])
        setSelectedTooths([])
        setSelectMaterial([])
        setRestorativeCondition([])
        setMaterial([])
        setproviderId(0)
        setTeethsList((prevTeeths) =>
            prevTeeths.map((tooth) => ({ ...tooth, selected: false }))
        );
        setDentitionAge('')
        setSurfaces((prevSurfaces) =>
            prevSurfaces.map((surface) => ({ ...surface, checked: false }))
        );
        setCount({ teethCount: '', surfaceCount: '' })
    }

    const clearProcedure = () => {
        setSelectProcedureModal({ data: null, open: false })
        setFilter({ category: '', code: null, description: null, search: null })
        setActive('')
        setProcedureList([])
        setSelectedProcedureCode([])
    }
    const handleCheckboxChange = (item) => {
        if (selectedItems.includes(item)) {
            // If the item is already selected, remove it from the selectedItems array
            setSelectedItems(selectedItems.filter((selectedItem) => selectedItem !== item));
            setChangeIdForm({ phaseId: "", tplanId: "" });
        } else {
            // If the item is not selected, add it to the selectedItems array
            setSelectedItems([...selectedItems, item]);
            setChangeIdForm({ phaseId: "", tplanId: "" });
        }
    };

    // handleChangeIdInput
    const handleChangeIdInput = (event) => {
        const { name, value } = event.target;
        setChangeIdForm((prev) => ({ ...prev, [name]: value }));
    };



    const isValid = () => {
        const newErrors = {};
        const { caseType, providerId, typeOfService, placeOfService } = newdata;

        if (!caseType) {
            newErrors.caseType = "Case type is required";
        }
        if (!providerId) {
            newErrors.providerId = "Provider Name is required";
        }

        if (!typeOfService) {
            newErrors.typeOfService = "Type Of Service";
        }
        if (!placeOfService) {
            newErrors.placeOfService = "Place Of Service";
        }

        setClaimFormError(newErrors);
        return Object.keys(newErrors).length === 0;
    };





    const submitClaim = async () => {
        // if (!isValid()) return
        let doctorIds = [];
        let allSameDoctor = null;

        if (selectedItems?.length > 1) {
            doctorIds = selectedItems.map(item => item?.doctorId);
            allSameDoctor = doctorIds.every(id => id === doctorIds[0]);

            if (!allSameDoctor) {
                return toast.warn("Claims cannot be processed for multiple providers.");
            }
        }

        const payload = {
            clinicId: user?.clinic_id,
            patientId: PatientData?.id,
            treatmentPlanId: selectedItems?.map(item => item?.id),
            providerId: selectedItems.length === 1 ? selectedItems[0]?.doctorId : doctorIds[0],

            placeOftreatment: submitClaimForm.placeOftreatment?.toString(),
            encloser: submitClaimForm.encloser,
            treatmentOfOrtho: submitClaimForm.treatmentOfOrtho,
            orthoDate: submitClaimForm.orthoDate ? moment(submitClaimForm.orthoDate).format("MM/DD/YYYY") : null,
            monthOfTreatment: submitClaimForm.monthOfTreatment,
            replacementOfProsthesis: submitClaimForm.replacementOfProsthesis,
            placementDate: submitClaimForm.placementDate ? moment(submitClaimForm.placementDate).format("MM/DD/YYYY") : null,
            dateAutoAccident: submitClaimForm.dateAutoAccident ? moment(submitClaimForm.dateAutoAccident).format("MM/DD/YYYY") : null,
            autoAccidentState: submitClaimForm.autoAccidentState,
            remarks: submitClaimForm.remarks,
            treatmentResultingForm: submitClaimForm?.treatmentResultingForm,
            isDental: submitClaimForm?.isDental,
            isMedical: submitClaimForm?.isMedical
        };

        try {
            setSpinner(true);
            const response = await GENERATE_CLAIM_FORM(payload);
            toast.success(response?.message);

            // Extract fullPath array and trigger downloads for all files
            const files = response?.data || [];
            if (files?.length > 0) {
                files?.forEach(file => {
                    const fileUrl = file?.fullPath;
                    if (fileUrl) {
                        // const link = document.createElement("a");
                        // link.href = fileUrl;
                        // link.download = fileUrl.split("/").pop(); 
                        // link.target = "_blank";
                        // document.body.appendChild(link);
                        // link.click();
                        // document.body.removeChild(link);

                        window.open(fileUrl);
                        let tempLink = document.createElement('a');
                        tempLink.setAttribute('download', fileUrl);
                        tempLink.click();
                        window.open(fileUrl)

                    } else {
                        console.warn("File URL not found:", file);
                    }
                });
            } else {
                toast.error("No files found to download.");
            }
            clearClaimForm()
            setSubmitClaimFormModal(modalEnum)
            setSelectedItems([]);
        } catch (error) {
            toast.error(error?.message);
        }
        setSpinner(false);
    };



    // Provider List
    const getProviderList = async () => {
        try {
            let payload = {
                count: 1000,
                page: 1,
                roleName: "PROVIDER"
            };
            setSpinner(true);
            let response = await PROVIDER_LIST(payload);
            let updatedProviderList = response?.data?.map((item) => ({
                ...item,
                fullName: `${item.firstName} ${item.lastName}`
            }));
            let allOption = { lastName: "ALL", userId: 0 };
            let setAllOption = [allOption, ...updatedProviderList];
            setProviderData(setAllOption);
            //   setProviderId(0);
        } catch (error) {
            toast.error(error);
        } finally {
            setSpinner(false);
        }
    };

    // TREATMENTPLAN_CHANGE_STATUS


    const changeStatus = async () => {
        if (!selectedOption) return toast.warn('Please select')
        try {
            let payload = {
                id: selectedItems?.length ? selectedItems?.map((item) => item?.id) : [],
                type: changeIdModal?.type,
                value: selectedOption
            }
            setSpinner(true)
            let response = await TREATMENTPLAN_CHANGE_STATUS(payload)
            toast.success(response?.message)
            setChangeIdModal(modalEnum)
            setSelectedItems([])
            setSelectedOption('')
            treatmentList()
        } catch (error) {
            toast.error(error?.message)
        }
        setSpinner(false)
    }
    const planDiscount = async () => {
        if (!discount) return toast.warn('Please enter discount')
        try {
            let payload = {
                id: selectedItems?.length ? selectedItems?.map((item) => item?.id) : [],
                discount: +discount
            }
            setSpinner(true)
            let response = await TREATMENTPLAN_DISCOUNT(payload)
            toast.success(response?.message)
            setChangeIdModal(modalEnum)
            setSelectedItems([])
            setSelectedOption('')
            treatmentList()
        } catch (error) {
            toast.error(error?.message)
        }
        setSpinner(false)
    }

    const handleInputChange = (event) => {
        let { name, value } = event.target
        setNewdata((prev) => ({
            ...prev,
            [name]: value
        }))
        // setClaimFormError((prev) => {
        //     const { [name]: removed, ...rest } = prev;
        //     return rest;
        // });
    }
    const handleRadioChange = (event) => {
        const { name, value } = event.target;
        setNewdata((prev) => ({
            ...prev,
            [name]: value,
        }));
        // setClaimFormError((prev) => {
        //     const { [name]: removed, ...rest } = prev;
        //     return rest;
        // });
    };

    const addNewAppointmentFun = () => {
        if (selectedItems?.length === 0) return toast.warn("Please select at least one treatment plan")
        Dispatch(add(selectedItems))
        navigate("/appointment_scheduler")
    }

    const handlePrint = (type) => {
        window.open(`/print/${'type'}/${'this.formId'}`, '', 'width=1100,height=900')
    }
    const getConditionsList = async () => {
        let payload = {
            clinicId: user?.clinic_id
        }
        try {
            setSpinner(true)
            let response = await CONDITIOIN_LIST(payload)
            setConditionList(response?.data)
        } catch (error) {
            setConditionList([])
            toast.error(error.message)
        }
        setSpinner(false)
    }

    const getMaterialList = async (id) => {
        let payload = {
            condition: id
        }
        try {
            setSpinner(true)
            let response = await MATERIAL_LIST(payload)
            setMaterialList(response?.data)
        } catch (error) {
            setMaterialList([])
            toast.error(error.message)
        }
        setSpinner(false)
    }

    useEffect(() => {
        if (superBillIstrue === "true") {
            getDiagnosisCodeList()
            getProivderList()
            getTreatmentList()
            getPatientDetailsSuperBill()
            listPatientDetailsSuperBill()
        }
    }, [superBillIstrue])

    useEffect(() => {
        listPatientDetailsSuperBill()
    }, [])

    const [diagnosisLoaded, setDiagnosisLoaded] = useState(false);

    useEffect(() => {
        if (id) {
            getDiagnosisCodeList().then(() => setDiagnosisLoaded(true));
        }
    }, []);

    const getDiagnosisCodeList = async () => {
        let payload = {
            isActive: true,
            clinicId: user?.clinic_id,
            isDeleted: false
        }
        try {
            setSpinner(true)
            let response = await DIAGNOSIS_CODE_LIST(payload)

            const formattedCode = response?.data?.map((item) => ({
                code: item.code,
                category: item.category,
                description: item.description,
                id: item.id,

            }));
            setIcdCodes(formattedCode);
            return true;
        } catch (error) {
            toast.error(error.message)
            setSpinner(false)
        } finally {
            setSpinner(false)
        }
    }

    useEffect(() => {
        if (diagnosisLoaded && id) {
            getProivderList();
            getTreatmentList();
            getSuperBillData();
        }
    }, [diagnosisLoaded, id]);




    const [providerList, setProviderList] = useState([])
    const [patientSuperBillDetails, setPatientSuperBillDetails] = useState([])
    const [patientSuperBillList, setPatientSuperBillList] = useState([])


    // providerList
    const getProivderList = async (providerId) => {
        try {
            let payload = {
                locationId: user?.location_id
            }
            setSpinner(true)
            let response = await GET_PROVIDER_HYGIENIST_LIST(payload)
            const formattedCode = response?.data?.map((item) => ({
                id: item.id,
                name: item.name,
            }));
            setProviderList(formattedCode);


        } catch (error) {

        }
        setSpinner(false)
    }


    const getTreatmentList = async () => {

        try {
            let response = await GET_TREATMENT_PLACE_LIST()

            const formattedCode = response?.data?.map((item) => ({
                code: item.code,
                name: item.name,
            }));
            setPlaceOfTreatment(formattedCode)
        } catch (error) {
            toast.error(error.message)
        }

    }


    const getPatientDetailsSuperBill = async () => {
        let payload = {
            patientId: PatientData?.id,
            locationId: user?.location_id
        }
        try {
            setSpinner(true)
            let response = await PATIENT_DETAILS_SUPERBILL(payload)
            setPatientSuperBillDetails(response.data)
        } catch (error) {
            toast.error(error.message)
            setSpinner(false)
        } finally {
            setSpinner(false)
        }
    }

    const listPatientDetailsSuperBill = async () => {
        let payload = {
            patientId: PatientData?.id,
            locationId: user?.location_id,
            clinicId: user?.clinic_id,
            count: "100",
            page: "1",
            batch: "Pending"
        }
        try {
            setSpinner(true)
            let response = await LIST_PATIENT_DETAILS_SUPERBILL(payload)
            setPatientSuperBillList(response.data)
        } catch (error) {
            toast.error(error.message)
            setSpinner(false)
        } finally {
            setSpinner(false)
        }
    }

    const getSuperBillData = async () => {
        if (!id) return;
        try {
            const response = await GET_PATIENT_DETAILS_SUPERBILL(id); // ✅ still uses id to get response
            const data = response.data;

            const mapIcdIdsToObjects = (ids = [], category) => {
                return ids.map((icdId) => {
                    const matched = icdCodes.find(item => String(item.id) === String(icdId));
                    return {
                        id: matched?.id || icdId,
                        code: matched?.code || '',
                        description: matched?.description || '',
                        category,
                    };
                });
            };

            const icd9Mapped = mapIcdIdsToObjects(data.icd9, 'ICD_9');
            const icd10Mapped = mapIcdIdsToObjects(data.icd10, 'ICD_10');

            // ✅ Update your state with the mapped ICD objects
            setNewdata(prev => ({
                ...prev,
                ...data,
                icdCodes: {
                    ICD_9: icd9Mapped,
                    ICD_10: icd10Mapped,
                },
            }));

        } catch (error) {
            console.error("Error fetching superbill data:", error);
            toast.error(error.message || "Failed to fetch Superbill data");
        }
    };

    const handleSubmitBill = async () => {
        if (!isValid()) return;
        let doctorIds = [];
        let allSameDoctor = null;

        if (selectedItems?.length > 1) {
            doctorIds = selectedItems.map(item => item?.doctorId);
            allSameDoctor = doctorIds.every(id => id === doctorIds[0]);

            if (!allSameDoctor) {
                return toast.warn("Claims cannot be processed for multiple providers.");
            }
        }

        if (!newdata?.icdCodes?.ICD_10?.length) {
            return toast.warn("One ICD is required.");
        }
        const payload = {
            locationId: user?.location_id,
            clinicId: user?.clinic_id,
            patientId: PatientData?.id,
            treatmentPlanId: selectedItems?.map(item => item?.id),
            providerId: selectedItems.length === 1 ? selectedItems[0]?.doctorId : doctorIds[0],

            totalAmount: newdata?.totalAmount,
            insurancePortion: newdata?.insurancePortion,
            // toDOS: allListData?.chargereviewdata?.checkInTime,
            status: "CHECKEDOUT",
            coverage: newdata?.coverage || 1,
            caseType: newdata?.caseType,
            // providerId: newdata?.providerId,
            billingProviderId: newdata?.billingProviderId || null,
            renderingProviderId: newdata?.renderingProviderId || null,
            referringProviderId: newdata?.referringProviderId || null,
            typeOfService: newdata?.typeOfService,
            placeOfService: newdata?.placeOfService,
            encloser: newdata?.encloser,
            treatmentOfOrtho: newdata?.treatmentOfOrtho,
            orthoDate: newdata?.orthoDate ? moment(newdata?.orthoDate).format("YYYY-MM-DD") : null,
            monthOfTreatment: newdata?.monthOfTreatment,
            replacementOfProsthesis: newdata?.replacementOfProsthesis,
            placementDate: newdata?.placementDate ? moment(newdata?.placementDate).format("YYYY-MM-DD") : null,
            dateAutoAccident: newdata?.dateAutoAccident ? moment(newdata?.dateAutoAccident).format("YYYY-MM-DD") : null,
            autoAccidentState: newdata?.autoAccidentState,
            remarks: newdata?.remarks,
            treatmentResultingForm: newdata?.treatmentResultingForm,
            isDental: newdata?.isDental,
            isMedical: newdata?.isMedical,
            // icd9: newdata?.icdCodes?.ICD_9 || [],
            icd9: newdata?.icdCodes?.ICD_9?.map(item => item.id) || [],
            icd10: newdata?.icdCodes?.ICD_10?.map(item => item.id) || [],
            cptCode: newdata?.cptCode?.map((item, index) => ({
                unit: item.unit,
                codeId: item.id,
                icd: item.icd || [],
                procedureDate: moment(item.date).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                areaOfOralCavity: item?.surfaceObjects?.[0]?.value,
                // toothSystem: "JP",
                toothNumber: item.toothNo,
                toothSurface: item?.surfaceObjects?.[0]?.value,
                modifier: [],
                cptDetailsData: {
                    id: item?.id,
                    code: item?.adaCode?.code,
                    description: item?.adaCode?.description,
                    abbrev: item?.adaCode?.abbrev,
                    fees1: item?.fee1,
                    fees2: item?.fee2
                }
            })),
            showReferringProvider: newdata?.showReferringProvider || false,
            acceptAssignment: acceptAssignment,
            payerId: patientSuperBillDetails?.insuranceDetail?.[0]?.payerId,
            insuranceCompanyName: patientSuperBillDetails?.insuranceDetail?.[0]?.insuranceCompanyName,
            responsibleParty: patientSuperBillDetails?.patientDetail?.responsibleParty,
            insurancePlan: patientSuperBillDetails?.insuranceDetail?.[0]?.insurancePlan,

        };

        try {
            setSpinner(true);
            const response = await PATIENT_DETAILS_SUPERBILL_GENERATE(payload);
            if (response.code === 401) {
                toast.error(response.message)
                return;
            }
            toast.success(response?.message)
            setSpinner(false);
            setSuperBillIstrue(false)
            setSelectedItems([])
            treatmentList()
        } catch (error) {
            // setAllListData(pre => ({ ...pre, chargereviewdata: [] }));
            setSpinner(false);
        }
    }

    const handleUpdateBill = async () => {
        if (id) {
            // if (!isValid()) return
            if (!newdata?.icdCodes?.ICD_10?.length) {
                return toast.warn("One ICD is required.");
            }

            const invalidUnitRow = newdata?.cptCode?.find(
                (item) =>
                    item.unit === null ||
                    item.unit === undefined ||
                    item.unit === '' ||
                    Number(item.unit) <= 0
            );

            if (invalidUnitRow) {
                toast.error("Each CPT Code must have a valid unit (greater than 0)");
                return;
            }

            const payload = {
                id: id,
                providerId: newdata.providerId,
                totalAmount: newdata?.totalAmount,
                insurancePortion: newdata?.insurancePortion || null,
                // toDOS: allListData?.chargereviewdata?.checkInTime,
                status: "CHECKEDOUT",
                coverage: newdata?.coverage || 1,
                caseType: newdata?.caseType,
                // providerId: newdata?.providerId,
                billingProviderId: newdata?.billingProviderId || null,
                renderingProviderId: newdata?.renderingProviderId || null,
                referringProviderId: newdata?.referringProviderId || null,
                typeOfService: newdata?.typeOfService,
                placeOfService: newdata?.placeOfService,
                encloser: newdata?.encloser || null,
                treatmentOfOrtho: newdata?.treatmentOfOrtho || null,
                orthoDate: newdata?.orthoDate ? moment(newdata?.orthoDate).format("YYYY-MM-DD") : null,
                monthOfTreatment: newdata?.monthOfTreatment,
                replacementOfProsthesis: newdata?.replacementOfProsthesis,
                placementDate: newdata?.placementDate ? moment(newdata?.placementDate).format("YYYY-MM-DD") : null,
                dateAutoAccident: newdata?.dateAutoAccident ? moment(newdata?.dateAutoAccident).format("YYYY-MM-DD") : null,
                autoAccidentState: newdata?.autoAccidentState || null,
                remarks: newdata?.remarks || null,
                treatmentResultingForm: newdata?.treatmentResultingForm || null,
                isDental: newdata?.isDental || null,
                isMedical: newdata?.isMedical || null,
                // icd9: newdata?.icdCodes?.ICD_9 || [],
                icd9: newdata?.icdCodes?.ICD_9?.map(item => item.id) || [],
                icd10: newdata?.icdCodes?.ICD_10?.map(item => item.id) || [],
                cptCode: newdata?.cptCode?.map((item, index) => ({
                    unit: item.unit,
                    codeId: item.codeId,
                    icd: item.icd || index + 1 || [],
                    procedureDate: item.procedureDate,
                    areaOfOralCavity: item?.surfaceObjects?.[0]?.value,
                    // toothSystem: "JP",
                    toothNumber: item.toothNumber,
                    toothSurface: item.toothSurface,
                    modifier: [],
                    cptDetailsData: {
                        code: item?.cptDetailsData?.code,
                        description: item?.cptDetailsData?.description,
                        abbrev: item?.cptDetailsData?.abbrev,
                        fees1: item?.cptDetailsData?.fees1,
                        fees2: item?.cptDetailsData?.fees2
                    }
                })),
                showReferringProvider: newdata?.showReferringProvider || false,
                acceptAssignment: newdata?.acceptAssignment || null,
                payerId: newdata?.payerId || null,
                insuranceCompanyName: newdata?.insuranceCompanyName || null,
                responsibleParty: newdata?.responsibleParty || null,
                insurancePlan: newdata?.insurancePlan || null,

            };

            try {
                setSpinner(true);
                const response = await PATIENT_DETAILS_SUPERBILL_UPDATE(payload);
                if (response.code === 401) {
                    toast.error(response.message)
                    return;
                }
                toast.success(response?.message)
                setSpinner(false);
                navigate("/superbill-list")
            } catch (error) {
                // setAllListData(pre => ({ ...pre, chargereviewdata: [] }));
                setSpinner(false);
            }
        }
    }

    const handleGenerateAda = async (adaId) => {
        const payload = { id: adaId };

        try {
            setSpinner(true);

            const response = await GENERATE_FORM_SUPERBILL(payload);
            const pdfList = response?.data;

            if (Array.isArray(pdfList) && pdfList.length > 0) {
                pdfList.forEach(pdf => {
                    if (pdf.fullPath) {
                        window.open(pdf.fullPath, "");
                    }
                });
            } else {
                toast.warn("No PDF links found.");
            }

        } catch (error) {
            toast.error(error.message);
        } finally {
            setSpinner(false);
        }
    };

    return {
        methods: {
            setTplanId,
            setPhaseId,
            setOrderId,
            setSelectProcedureModal,
            getProcedureList,
            setSelectedProcedureCode,
            getProcedureCategoryList,
            setActive,
            setFilter,
            setController,
            ApplyFilter,
            resetFilter,
            setTplanDate,
            setProcedureList,
            setToothModal,
            setSelectToothModal,
            handleSelectedTooths,
            handleSubmitTooths,
            setSurfaceModal,
            handleSelectedSurface,
            handleSubmitSurfaces,
            getMaterial,
            setMaterial,
            setSelectMaterial,
            addTreatmentPlan,
            clear,
            clearProcedure,
            setDeleteModal,
            handleDelete,
            handleCheckboxChange,
            // change Id Modal----------
            setChangeIdModal,
            handleChangeIdInput,
            submitClaim,
            setChangeIdForm,
            setChangeStatusModal,
            addNewAppointmentFun,
            handleRadioChange,
            setSelectedOption,
            changeStatus,
            setDiscount,
            planDiscount,
            getProviderList,
            setproviderId,
            handlePrint,
            getConditionsList,
            getMaterialList,
            setRestorativeCondition,
            setDentitionAge,
            setSubmissionStatus,
            // SubmitClaim Form
            setSubmitClaimFormModal,
            setSubmitClaimForm,
            handleInputChange,
            clearClaimForm,
            setSuperBillIstrue,
            setNewdata,
            handleSubmitBill,
            setResponsibleParty,
            setAcceptAssignment,
            handleUpdateBill,
            setClaimFormError,
            handleGenerateAda
        },

        data: {
            tplanId,
            phaseId,
            orderId,
            tPlanIdList,
            phaseList,
            orderList,
            selectProcedureModal,
            spinner,
            procedureList,
            selectedProcedureCode,
            categoryList,
            active,
            listData,
            totalCount,
            controller,
            tplanDate,
            currentProcedure,
            filter,
            toothModal,
            teethsList,
            selectToothModal,
            surfaceModal,
            surfaces,
            material,
            selectMaterial,
            count,
            deleteModal,
            // change Id Modal-----------
            selectedItems,
            changeIdModal,
            changeIdForm,
            changeStatusModal,
            selectedOption,
            providerData,
            providerId,
            conditionList,
            materialList,
            dentitionAge,
            restorativeCondition,
            submissionStatusArray,
            submissionStatus,
            // submit claim form
            submitClaimFormModal,
            submitClaimForm,
            palceOfTreatmentlist,
            claimFormError,
            superBillIstrue,
            icdCodes,
            newdata,
            providerList,
            patientSuperBillDetails,
            responsibleParty,
            acceptAssignment,
            patientSuperBillList
        }
    }
}

export default UseTreatmentPlan